var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4398 10.232C36.1838 7.87996 24.3598 6.51196 19.1198 11.664C13.7358 16.96 13.6958 34.864 18.9918 46.2C22.3518 53.4 16.6958 39.736 27.5598 35.272C42.9198 28.96 50.0078 47.096 49.1598 32C48.7998 25.504 55.0158 12.656 45.4398 10.232Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9681 50.808C19.4171 50.808 17.9297 50.1919 16.833 49.0952C15.7362 47.9984 15.1201 46.511 15.1201 44.96V13.84C15.1222 12.2904 15.7393 10.805 16.8358 9.71001C17.9323 8.61503 19.4185 8 20.9681 8H46.0321C47.5831 8 49.0706 8.61613 50.1673 9.71284C51.264 10.8096 51.8801 12.297 51.8801 13.848V44.96C51.8801 46.511 51.264 47.9984 50.1673 49.0952C49.0706 50.1919 47.5831 50.808 46.0321 50.808",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0081 19.2321H44.4641",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0081 28.472H44.4641",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5039 58.056C39.557 58.056 44.464 53.149 44.464 47.096C44.464 41.0429 39.557 36.136 33.5039 36.136C27.4509 36.136 22.5439 41.0429 22.5439 47.096C22.5439 53.149 27.4509 58.056 33.5039 58.056Z",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7279 43.32C30.2226 42.8229 30.8112 42.429 31.4594 42.1612C32.1076 41.8934 32.8026 41.7571 33.5039 41.76C34.4499 41.7582 35.3788 42.0125 36.1919 42.496L35.1119 42.64L35.2719 43.824L38.3999 43.416L37.9839 40.312L36.7999 40.472L36.9359 41.528C35.8131 40.8277 34.5043 40.4846 33.1823 40.5442C31.8604 40.6038 30.5877 41.0632 29.5325 41.8618C28.4773 42.6603 27.6894 43.7603 27.2729 45.0163C26.8564 46.2724 26.8309 47.6252 27.1999 48.896L28.3519 48.568C28.0945 47.6499 28.0863 46.6797 28.3281 45.7574C28.5699 44.835 29.0531 43.9937 29.7279 43.32ZM39.7599 45.2L38.6079 45.544C38.9238 46.5726 38.9209 47.6727 38.5995 48.6996C38.2781 49.7265 37.6533 50.6321 36.8074 51.297C35.9615 51.962 34.934 52.3553 33.8603 52.4251C32.7865 52.4948 31.7168 52.2379 30.7919 51.688L31.8879 51.536L31.7199 50.344L28.6239 50.792L29.0639 53.888L30.2559 53.72L30.1039 52.68C31.2347 53.3693 32.5483 53.6989 33.8706 53.625C35.1929 53.5511 36.4615 53.0773 37.5085 52.2662C38.5555 51.4552 39.3314 50.3452 39.7334 49.0833C40.1355 47.8215 40.1447 46.4672 39.7599 45.2Z",
    fill: "url(#paint0_linear_37816_3688)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4958 19.304L24.6718 21.48L29.1598 16.984",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4958 28.536L24.6718 30.72L29.1598 26.224",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37816_3688",
    x1: 26.9599,
    y1: 47.096,
    x2: 40.0399,
    y2: 47.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FF9793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF8AA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF80B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FF66D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsList);
export default __webpack_public_path__ + "static/media/icons-list.9977da4fec16a6ff08de4a1affa945a7.svg";
export { ForwardRef as ReactComponent };